module.exports = __webpack_public_path__ + "static/media/IOTApplication.5ec8afa3.png";